"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var AaChipsWrapper = function AaChipsWrapper(_ref) {
  var children = _ref.children,
      layout = _ref.layout;
  var rowLayout = layout <= _crossPlatformComponents.LAYOUT.mediumMobile;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.ScrollView, {
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    style: [styles.container]
  }, children);
};

var styles = _crossPlatformComponents.StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row'
  }
});

var _default = AaChipsWrapper;
exports["default"] = _default;